module.exports = __webpack_public_path__ + "55e6d0ff84eb6b2ba653b45a8199b87a.png";